import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderBy',
  standalone: false
})
export class OrderByPipe implements PipeTransform {

  transform(array: any[], field: string, direction: 'asc' | 'desc' = 'asc'): any[] {
    if (!Array.isArray(array) || array.length <= 1 || !field) {
      return array;
    }

    return array.slice().sort((a, b) => {
      const aValue = a[field];
      const bValue = b[field];

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      let comparison = 0;

      if (aValue < bValue) {
        comparison = -1;
      } else if (aValue > bValue) {
        comparison = 1;
      }

      return direction === 'asc' ? comparison : -comparison;
    });
  }
}
